type DemoTopic = {
  isDemo?: boolean;
  approved?: boolean;
  approval?: { approved?: boolean | string };
};

export const chapterHasApprovedDemo = (
  topics: readonly DemoTopic[] | undefined,
  chapterApproved = false,
): boolean => (topics ?? []).some((topic) => {
  if (topic.isDemo !== true) return false;
  const approval = topic.approval;
  return approval?.approved === true || approval?.approved === 'true' ||
    topic.approved === true ||
    (chapterApproved && (!approval || Object.keys(approval).length === 0));
});
